/**
 * Single breakpoint of the application.
 * The same value is repeated in src/variables.scss, src/global.css and
 * packages/my-lib/src/lib/responsive.ts. src/responsive.test.ts fails if they differ.
 */
export const MOBILE_BREAKPOINT = 720;
export const MOBILE_MEDIA_QUERY = `(max-width: ${MOBILE_BREAKPOINT}px)`;
export const mq = { mobile: `@media ${MOBILE_MEDIA_QUERY}` } as const;
